import React, { useState, useEffect } from 'react';
import './App.css';


type status = "yes" | "no" | "pending"

const statusInfo = {
  "yes": {
    message: "Dinnis IS coming for lunch today! Yippee!",
    image: "yes.gif",
    bg: "#28a859",
  },
  "no": {
    message: "Dinnis is NOT coming for lunch today :(",
    image: "no.gif",
    bg: "#7d270a",
  },
  "pending": {
    message: "Dinnis has not yet decided what he's doing for lunch today (or he forgot to update this, hmmmm)",
    image: "pending.gif",
    bg: "#94882b",
  }
};


function App() {
  const [status, setStatus] = useState<status>("pending")
  const [customMessage, setCustomMessage] = useState<string>()

  useEffect(() => {
    console.log("TEST")
    fetch("/api/status")
    .then((res) => res.json())
    .then((data) => {
        setStatus(data.status);
        setCustomMessage(data.message);
    })
  }, [])

  const { message, image, bg } = statusInfo[status];

  return (
    <div className="App">
      <div className="Title">Is Dinnis coming for lunch today??</div>
      <div className="Answer" style={{ backgroundColor: bg }}>
        <p className="Message">{customMessage ? customMessage : message}</p>
        <img className="Image" src={image} />
      </div>
    </div>
  );
}

export default App;
